import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@scaffold/services/settings.service';
import { setting } from '@scaffold/editor/settings';
import cloneDeep from 'lodash/cloneDeep';
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { PropertiesService } from '../../../services/properties.service';

@Component({
  selector: 'app-controls-modal',
  templateUrl: './controls-modal.component.html',
  styleUrls: ['./controls-modal.component.css']
})
export class ControlsModalComponent implements OnInit {
  settings: setting;
  selectedItem: any;
  item: any;
  dataItems = [];
  type;
  parentView;
  data: any = {};
  constructor(private settingsService: SettingsService, public dialogRef: ScaffoldDialogRef, public properties: PropertiesService) {
    settingsService.getSettings().subscribe(settings => this.settings = settings);
    console.log(this.data);
  }

  closeDialog(item) {
    if (item) {
      this.dialogRef.close(item);
    } else {
      this.dialogRef.close(null);
    }
  }

  updateOptions(e) {
    console.log(e);
    this.properties.changeValue();
  }

  arrayLength(target, key, count, defaults) {
    console.log(target, key);
    if (!target.hasOwnProperty(key))
      target[key] = [];
    target = target[key];
     
    count = target.length + count;
    console.log(count);
    if (target.length > count) {
      while (target.length > count) {
        target.splice(target.length - 1, 1);
      }
    } else {
      while (target.length < count) {
        target.push(cloneDeep(defaults));
      }
    }
  }
  moveItem(item, arr:any[], index, dir) {
    let target = index + dir;
    arr.splice(target, 0, item)
    console.log(index);
    if (dir < 0) {
      index += 1;
    }
    arr.splice(index, 1)
  }
    

  ngOnInit() {
    this.selectedItem = this.data.selectedItem;
    this.item = this.data.item;
    this.parentView = this.data.parentView;
  }
}
